/**
 *
 * @module subscriptionSourceType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionSourceType
 * @type {Object}
 *
 * @property {String} D2C
 * @property {String} MVPD
 * @property {String} IAP
 * @property {String} CST
 * @property {String} OTHER
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionSourceType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access private
     * @type {String}
     *
     */
    D2C: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    MVPD: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    IAP: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    CST: null,
    /**
     *
     * @access private
     * @type {String}
     *
     */
    OTHER: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionSourceType.js